
export default function ReportsOptions(request) {

  const  today = new Date().toISOString().split('T')[0];
  const  defaultFromDate = `${today} 00:00:00`
  const  defaultToDate = `${today} 23:59:59`

  function getDeferanceInDays(date1,date2){
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Difference_In_Days;
  }

  function getRange(dateStr){

    let rangeKeys = ['from', 'to']
    let dateTimeKeys = ['date', 'time']

    return Object.fromEntries(new Map(dateStr.split(' to ').map((dateTime, index)=> {
      return [
        rangeKeys[index], 
        Object.fromEntries(new Map(dateTime.split(' ').map((value, index)=> {
          return [dateTimeKeys[index], value]
        })))
      ]
    })))
  }

  let toDateChangeCounter = 0;
  let firstDate = null;
   const  pickerOptions = {
        dateFormat: 'Y-m-d H:i:S',
        defaultDate: [
          new Date().setHours(0,0,0),
          new Date().setHours(23, 59, 59, 59),
        ],
        enableTime: true,
        enableSeconds: true,
        defaultHour: 0,
        mode: 'range',
        time_24hr: true,
        onClose: function(selectedDates, dateStr, instance) {
          const date = dateStr.split(' to ')
          request.from = date[0]
          request.to = date[1]
        },
        onChange(selectedDates, dateStr, instance) {

          if(!Object.keys(instance).includes('currentRange')){
            instance.currentRange = getRange(`${defaultFromDate} to ${defaultToDate}`)
          }

          let newRange = getRange(dateStr)

          if(Object.keys(newRange).includes('from')){
            if(newRange.from.date != instance?.currentRange?.from?.date){
              this.selectedDates[0].setHours(0, 0, 0, 0)
              this.setDate(this.selectedDates)
            }
          }

          if(Object.keys(newRange).includes('to')){
            if(newRange.to.date != instance?.currentRange?.to?.date){
              this.selectedDates[1].setHours(23, 59, 59, 59)
              this.setDate(this.selectedDates)
            }
          }

          this.currentRange = newRange

        }
      }


      return {pickerOptions, defaultFromDate, defaultToDate}

}



